<template>
  <div class="h-100"
       :style="'background: url(src/assets/img/main-slider/'+contentSlide.image+'; background-size: cover'">
    <div class="overlay-slide h-100 d-flex flex-column justify-content-center">
      <div class="p-3">
        <v-col class="text-wrap text-justify" justify="space-around" v-html="contentSlide.text_html"></v-col>
        <v-row v-if="page === 0" align="center" justify="space-around">
          <router-link to="connection">
            <v-btn color="primary">S'inscrire</v-btn>
          </router-link>
          <router-link to="offres">
            <v-btn>Les offres</v-btn>
          </router-link>
        </v-row>
        <v-row v-if="page === 1" class="pb-5" align="center" justify="center">
          <router-link to="">
            <v-btn class="text-uppercase" color="primary">-10% réduction prévue</v-btn>
          </router-link>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: "Index",
  props: {
    contentSlide: {
      type: Object
    },
    page: {
      type: Number
    }
  },
  data () {
    return {}
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.animate__animated{
  --animate-duration: 1s;
  --animate-delay: 2s;
}
.overlay-slide{
  background-color: var(--color-first-0-3, rgba(0,0,0,.3));
}
.overlay-slide:hover{
  background-color: var(--color-first-0-5, rgba(0,0,0,.5));
}
main {}

@media (min-width: 576px) {
  main {}
}

@media (min-width: 768px) {
  main {}
}

@media (min-width: 992px) {
  main {}
}

@media (min-width: 1200px) {
  main {}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ContentSlide.vue